import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(3),
    }
  },
  textFieldWrapper: {
    position: 'relative'
  },
  inputIcon: {
    height: 20,
    left: 15,
    position: 'absolute',
    top: 17,
    width: 20
  },
  formControl: {
    '& .MuiSvgIcon-root': {
      fontSize: '2rem'
    },
    '& .MuiChip-root': {
      borderRadius: '4px',
      backgroundColor: '#f5f5f5',
    },
    '& .MuiChip-root span': {
      height: '18px',
      fontSize: '16px',
      fontFamily: 'CircularStd',
      lineHeight: '1.13',
      letterSpacing: '-0.5px',
      color: '#4a4a4a',
      padding: '10px 15px 10px 10px',
    },
    '& .MuiChip-root .MuiSvgIcon-root.MuiChip-deleteIcon': {
      width: 12,
      height: 12,
      '& path': {
        d: 'M16.5 6.4625L15.5375 5.5L11 10.0375L6.4625 5.5L5.5 6.4625L10.0375 11L5.5 15.5375L6.4625 16.5L11 11.9625L15.5375 16.5L16.5 15.5375L11.9625 11L16.5 6.4625Z',
      }
    },
    '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      paddingRight: 35,
      minHeight: 56,
      position: 'relative',
      '& .MuiAutocomplete-tag': {
        position: 'relative',
        zIndex: '11'
      },
      '& .MuiAutocomplete-input': {
        padding: 0,
        width: '100%',
        position: 'absolute',
        height: '100%',
        left: '0',
        top: '0',
        zIndex: '10'
      },
      '& .MuiAutocomplete-clearIndicator': {
        position: 'relative',
        zIndex: '11'
      }
    }
  },
  popper: {
    '& .MuiAutocomplete-paper': {
      minWidth: 300
    }
  },
  stateIcon: {
    backgroundColor: '#FFF',
    borderRadius: 100,
    height: 20,
    padding: 0,
    position: 'absolute',
    right: -8,
    top: -8,
    width: 20
  },
});
